import { HttpErrorResponse } from "@angular/common/http";

export interface FgbErr{
    message: string;
    translateKey: string;
    clearAfter: number;
}

/**
 * Error will be thrown to the error handler and the error handler will handle the error and translate the error message.
 * @see {@link FgbErrorHandler}
 * @param message - The error message to be displayed
 * @param translateKey - The key to be used to translate the error message
 * @param showInConsole - If true, the error will be displayed in the console
 * @param clearAfter - The time in milliseconds to clear the error message
 */
export class FgbError implements FgbErr{
    message: string;
    translateKey: string;

    constructor(o?: any, public showInConsole: boolean = false, public clearAfter: number = 3000){
        o = o || {};
        this.message = o.message || '';
        this.translateKey = o.translateKey || '';
      
        if( o instanceof HttpErrorResponse){
            this.message = o.message;
            this.translateKey = `error.code.${o.status}`;

            if( o.error && o.error.Message){
                this.message = o.error.Message;
            }

            if( o.error && o.error.Code ){
                this.translateKey = `error.${o.error.Code}`;
            }
        }
    }
}